"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const static_colors_1 = __importDefault(require("../../global/static-colors"));
const shadows = {
    elevation1: [
        {
            x: 0,
            y: 1,
            radius: 12,
            color: static_colors_1.default.neutralGrey900,
            opacity: 0.03,
        },
        {
            x: 0,
            y: 1,
            radius: 4,
            color: static_colors_1.default.neutralGrey900,
            opacity: 0.04,
        },
    ],
    elevation2: [
        {
            x: 0,
            y: 1,
            radius: 8,
            color: static_colors_1.default.neutralGrey900,
            opacity: 0.03,
        },
        {
            x: 0,
            y: 2,
            radius: 16,
            color: static_colors_1.default.neutralGrey900,
            opacity: 0.03,
        },
    ],
    elevation3: [
        {
            x: 0,
            y: 2,
            radius: 8,
            color: static_colors_1.default.neutralGrey900,
            opacity: 0.05,
        },
        {
            x: 0,
            y: 4,
            radius: 12,
            color: static_colors_1.default.neutralGrey900,
            opacity: 0.03,
        },
    ],
    elevation4: [
        {
            x: 0,
            y: 2,
            radius: 8,
            color: static_colors_1.default.neutralGrey900,
            opacity: 0.05,
        },
        {
            x: 0,
            y: 8,
            radius: 16,
            color: static_colors_1.default.neutralGrey900,
            opacity: 0.04,
        },
    ],
};
exports.default = shadows;
//# sourceMappingURL=shadows.js.map